<template>
  <div>
    <div class="common-box border-t0">
      <el-row class="row-one">
        <span class="row-one-title">配置详情</span>
        <span class="row-one-subTitle">{{fundName}}</span>
        <Reback class="row-one-fr" @click.native="returnOne"></Reback>
        <span class="row-one-fr">{{'持仓差异：' + ChaYi}}</span>
      </el-row>

      <div class="fundTableBox">
        <!-- 股票型 -->
        <div class="fundTableBox_sm">
          <div class="tit">{{'股票型(' + stockType + ')'}}</div>
          <div class="con">
            <!-- 表格 -->
            <el-table :data="stockTableData" class="table-two" style="width: 100%">
              <el-table-column prop="FundCode" label="基金代码">
              </el-table-column>
              <el-table-column prop="FundName" label="基金名称">
              </el-table-column>
              <el-table-column prop="FundPro" label="持有组合">
              </el-table-column>

            </el-table>
          </div>
        </div>
        <div class="sm" style="width:15px;display: inline-block;"></div>
        <!-- 混合型 -->
        <div class="fundTableBox_sm">
          <div class="tit">{{'混合型(' + mixedType + ')'}}</div>
          <div class="con">
            <el-table :data="mixedTableData" class="table-two" style="width: 100%">
              <el-table-column prop="FundCode" label="基金代码">
              </el-table-column>
              <el-table-column prop="FundName" label="基金名称">
              </el-table-column>
              <el-table-column prop="FundPro" label="持有组合">
              </el-table-column>

            </el-table>
          </div>
        </div>
      </div>
      <div class="fundTableBox">
        <!-- 债券 -->
        <div class="fundTableBox_sm">
          <div class="tit">{{'债券型(' + bondType + ')'}}</div>
          <div class="con">
            <!-- 表格 -->
            <el-table :data="bondTableData" class="table-two" style="width: 100%">
              <el-table-column prop="FundCode" label="基金代码">
              </el-table-column>
              <el-table-column prop="FundName" label="基金名称">
              </el-table-column>
              <el-table-column prop="FundPro" label="持有组合">
              </el-table-column>

            </el-table>
          </div>
        </div>
        <div class="sm" style="width:15px;display: inline-block;"></div>
        <!-- 货币 -->
        <div class="fundTableBox_sm">
          <div class="tit">{{'货币型(' + monetaryType + ')'}}</div>
          <div class="con">
            <el-table :data="monetaryTableData" class="table-two" style="width: 100%">
              <el-table-column prop="FundCode" label="基金代码">
              </el-table-column>
              <el-table-column prop="FundName" label="基金名称">
              </el-table-column>
              <el-table-column prop="FundPro" label="持有组合">
              </el-table-column>

            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  data () {
    return {
      fundName: '--',
      ChaYi: '--',
      stockTableData: [],
      mixedTableData: [],
      bondTableData: [],
      monetaryTableData: [],

      stockType: '0',//股票型
      mixedType: '0',//混合型
      bondType: '0',//债券型
      monetaryType: '0',//货币型
      fundCombinationData: '',
      fundCode: '',//基金代码
    }
  },
  created () {

    const msg = this.$route.params.message
    // console.log(msg);

    this.fundCombinationData = msg.combinationcode
    this.fundName = msg.funddesc
    this.ChaYi = msg.different ? msg.different : '--'
    this.fundCode = this.getCode(msg.combinationcode)
    // console.log(this.fundCode);
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    returnOne () {
      this.$router.push({
        name: 'myAssets'
      })
    },
    // 获取百分比
    getDetail () {
      this.$http.post(this.$apiPath.jingZhunChangeRecord, {
        id: this.fundCode
      }).then(res => {
        if (res.status !== 200) return
        // console.log(res);
        if (res.data.data.length > 0) {
          res.data.data.forEach(item => {
            if (item.Fundtype == "股票型") {
              item.Proportion.length > 6 ? this.stockType = item.Proportion.substring(0, 5) + '%' : this.stockType = item.Proportion
              this.stockTableData = item.Fundlist
            } else if (item.Fundtype == "混合型") {
              item.Proportion.length > 6 ? this.mixedType = item.Proportion.substring(0, 5) + '%' : this.mixedType = item.Proportion
              this.mixedTableData = item.Fundlist
            } else if (item.Fundtype == "债券型") {
              item.Proportion.length > 6 ? this.bondType = item.Proportion.substring(0, 5) + '%' : this.bondType = item.Proportion
              this.bondTableData = item.Fundlist
            } else if (item.Fundtype == "货币型") {
              item.Proportion.length > 6 ? this.monetaryType = item.Proportion.substring(0, 5) + '%' : this.monetaryType = item.Proportion
              this.monetaryTableData = item.Fundlist
            }
          })
        }

      })
    },
    getCode (code) {
      var id
      if (code == "ZHZ001") {
        id = 1
      } else if (code == "ZHZ002") {
        id = 2
      } else if (code == "ZHZ003") {
        id = 3
      } else if (code == "ZH0034") {
        id = 4
      } else if (code == "ZHZ000") {
        id = 5
      } else if (code == "ZH0004") {
        id = 6
      }
      return id
    }
  }
}
</script>

<style lang="less" scoped>
.fundTableBox {
  margin: 20px 0;
  &_sm {
    vertical-align: top;
    display: inline-block;
    width: calc(49.99% - 7.5px);
    height: 100%;
    // background: pink;
    .tit {
      font-size: 18px;
      color: #246ead;
      font-weight: bold;
    }
    .con {
      margin-top: 15px;
    }
  }
}
</style>